module.exports = __webpack_public_path__ + "img/magic-pen.09448139.svg";